import React, { useEffect } from 'react';
import { useTimer } from 'react-compound-timer';
import { useHintContainer } from '../../../context/useHintContainerContext';
import { returnHints } from '../../Round/helpers/index';

import UIfx from 'uifx';
import message from '../../../../../assets/messageHint.mp3';

const HintTimer = ({ allRounds, round }) => {
  const { hintsArray, addHintToQueue } = useHintContainer();

  const {
    value,
    controls: { reset, setCheckpoints },
  } = useTimer({
    initialTime: 0,
  });

  useEffect(() => {
    const returnedHints = returnHints(`round${round}`, allRounds);
    returnedHints.forEach((hint) => {
      hint.hint.callback = () => triggerHint(hint?.hint);
      hintsArray.push(hint.hint);
    });
    reset();
    setCheckpoints(hintsArray);
  }, [round]);

  const triggerHint = (hint) => {
    const messageSound = new UIfx(message, {
      volume: 0.3,
      throttleMs: 100,
    });
    messageSound.play();

    addHintToQueue(hint);
  };

  return <></>;
};

export default HintTimer;
